type EventSubpageMetadataProps = {
    divisionName?: string,
    eventName?: string,
    sportType?: string,
    eventDate?: string,
    eventLocation?: string,
    orgName?: string
    eventStatus?: string
}

export const getEventWithStatusMetadataDescription = ({ eventStatus, eventName, sportType, eventDate, eventLocation, orgName }: Omit<EventSubpageMetadataProps, "divisionName">) => {
    if (!eventStatus || !eventName || !sportType || !eventDate || !orgName) return;

    if (!sportType || sportType === "other") {
        if (eventLocation) return "event_with_status_meta_description_sport_type_other";
        return "event_with_status_meta_description_sport_type_other_no_location";
    }

    if (eventLocation) return "event_with_status_meta_description";
    return "event_with_status_meta_description_no_location";
};

export const getEventMetadataDescription = ({ eventName, sportType, eventDate, eventLocation, orgName }: Omit<EventSubpageMetadataProps, "eventStatus" | "divisionName">) => {
    if (!eventName || !sportType || !eventDate || !orgName) return;

    if (!sportType || sportType === "other") {
        if (eventLocation) return "event_meta_description_sport_type_other";
        return "event_meta_description_sport_type_other_no_location";
    }

    if (eventLocation) return "event_meta_description";
    return "event_meta_description_no_location";
};

export const getEventDivisionMetadataDescription = ({ divisionName, eventName, sportType, eventDate, eventLocation, orgName }: Omit<EventSubpageMetadataProps, "eventStatus">) => {
    if (!divisionName || !eventName || !sportType || !eventDate || !orgName) return;

    if (!sportType || sportType === "other") {
        if (eventLocation) return "event_division_meta_description_sport_type_other";
        return "event_division_meta_description_sport_type_other_no_location";
    }

    if (eventLocation) return "event_division_meta_description";
    return "event_division_meta_description_no_location";
};
